import React, { useState, useEffect } from "react";
import { AiFillTag as TagIcon } from "@react-icons/all-files/ai/AiFillTag";
import { AiFillCaretRight as RightIcon } from "@react-icons/all-files/ai/AiFillCaretRight";
import { evaluateHideComponent } from "@Modules/eventPage/utils/render";
import { isEmpty, pluralise, useData } from "@Utils";

import { DISCOUNT_OFF_TYPES } from "repoV2/features/Listing/Listing.constants";
import type { IOfferPromotion } from "./IOfferPromotion";

import OfferPopup from "./components/OfferPopup";

import styles from "./OfferPromotion.module.scss";

const OfferPromotion = ({
    currency,
    coupons,
    hideComponent,
    isMobile,
    showOn = "all",
    discountCode,
    callApplyDiscountApi,
}: IOfferPromotion.IProps) => {
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { setData: setHideWidget } = useData<boolean>("hideContactWidget");

    // @DEV: If a discount code is of the percentage type, it should be considered regardless of its currency. For other types of discount codes, we need to verify that the coupon currency matches the eventData currency.
    const totalCoupons = coupons.filter(
        coupon =>
            coupon.currency === currency ||
            coupon.type === DISCOUNT_OFF_TYPES.PERCENTAGE
    ).length;

    useEffect(() => {
        setHideWidget(showPopup);
    }, [showPopup]);

    useEffect(() => {
        setShowPopup(false);
    }, [isMobile]);

    if (evaluateHideComponent({ showOn, isMobile, hideComponent })) return null;

    const iconSize = isMobile ? 16 : 20;

    const popupProps = {
        closePopup: () => setShowPopup(false),
        coupons,
        discountCode,
        currency,
        applyCode: (codeProp: string) =>
            callApplyDiscountApi(codeProp, "normal"),
    };

    return (
        <div>
            <div
                className={styles.container}
                onClick={() => setShowPopup(true)}
            >
                <TagIcon size={iconSize} />
                <span>
                    &nbsp;
                    {!isEmpty(discountCode)
                        ? "Change Coupon"
                        : `Use ${pluralise("Coupon", coupons?.length)}`}
                    &nbsp;(
                    {totalCoupons} available)
                </span>
                <span className={styles.rightIcon}>
                    <RightIcon size={iconSize} />
                </span>
            </div>
            {showPopup ? <OfferPopup {...popupProps} /> : null}
        </div>
    );
};

export default OfferPromotion;
